import React from 'react'
import { formatRelativeDate } from '../constants/dateHelpers'

const typeIcons = {
  quote_imported: '\u2713',
  quote_uploaded: '\u2191',
  items_modified: '\u270E'
}

const RecentActivity = ({ activity }) => {
  return (
    <div className="hmi-panel">
      <div className="hmi-panel-head"><h4>Recent Activity</h4></div>
      <div className="hmi-panel-body">
        {!activity || activity.length === 0 ? (
          <div style={{ padding: 14, color: 'var(--ink-3)', fontSize: 13 }}>No activity yet.</div>
        ) : (
          activity.map((item, idx) => (
            <div key={idx} className="hmi-list-item">
              <span style={{ flexShrink: 0, color: 'var(--ink-3)', marginTop: 2 }}>
                {typeIcons[item.type] || '\u2022'}
              </span>
              <div style={{ flex: 1 }}>
                <div style={{ fontSize: 12.5 }}>{item.description}</div>
              </div>
              <span className="ts">{formatRelativeDate(item.date)}</span>
            </div>
          ))
        )}
      </div>
    </div>
  )
}

export default RecentActivity
